export default __webpack_public_path__ + "static/media/Image_not_available.924fb4ca.svg";